import formatter from '@/core/charts/helper/formatter'

export default {
  get: function (settings) {
    return {
      '*id': '_',
      supplierCompanyName: {
        label: 'Supplier',
        width: 100,
        editable: false
      },
      supplierInvoiceNumber: {
        label: 'Ref ID',
        width: 65,
        editable: false
      },
      programName: {
        label: settings.Labels.ProgramLabel + ' Name',
        width: 65,
        editable: false
      },
      divisionName: {
        label: settings.DivisionName,
        width: 65,
        editable: false
      },
      totalAmount: {
        label: 'Amount',
        compose: totalAmountFormat,
        getter: totalAmountFormat,
        width: 75,
        editable: false,
        type: 'amount text-right'
      }
    }
  }
}

function totalAmountFormat(params) {
  return formatter.getMoneyFormatedValue(params.data.totalAmount, params.data.currencyCode)
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/batch-invoice.js